export const PARENTAL_ITEMS = [
	{ year: "2021", title: "RELEMBRE A JORNADA DE AULAS 2021", link: "/jornada/PARENTAL/2021", button: "Assista" },
	{ year: "2022", title: "DESCUBRA A JORNADA DE AULAS 2022", link: "/jornada/PARENTAL/2022", button: "Assista" },
	{ year: "2023", title: "DESCUBRA A JORNADA DE AULAS 2023", link: "/jornada/PARENTAL/2023", button: "Assista" },
];
